import store from '@/store'

const productionRedirect = (store.getters.currentUserRole === 'brigadier' || store.getters.currentUserRole === 'production-master') ? { name: 'ConsignmentList' } : { name: 'Order' }

export default productionRedirect
